import { Box, CircularProgress, Snackbar } from '@mui/material';
import { MdOutlineClose } from 'react-icons/md';
import {
  FileUploadStatus,
  FileUploadStatusType,
} from '../../interfaces/tusFileUpload.interface';
import { imgAcceptTypeUpload } from '../../constant/fileType';
import Image from 'next/image';
import {
  UploadErrorIcon,
  UploadImgIcon,
  UploadNotImgIcon,
  UploadSuccessIcon,
} from '../../constant/imgImport';
import { memo, useMemo } from 'react';

export const autoHiddenUploadProgress = 3000;

const UploadProgress = ({
  fileList,
  isOpen,
  toggle,
}: {
  fileList: {
    file: File;
    status: FileUploadStatusType;
  }[];
  currentFileIndex: number;
  progress: number;
  isOpen: boolean;
  toggle: () => void;
}) => {
  const notPendingCondition = fileList.every(
    (item) => item.status !== FileUploadStatus.Pending
  );

  const autoHideDuration = useMemo(
    () => (notPendingCondition ? autoHiddenUploadProgress : null),
    [notPendingCondition]
  );

  const handleClose = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    toggle();
  };

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}
      disableWindowBlurListener={true}
      className="border rounded bg-white shadow"
    >
      <div className="flex flex-col w-screen sm:w-96 overflow-hidden">
        <div className="flex items-center justify-between px-4 pt-2 pb-4">
          <h1 className="text-xl">Tải lên tệp</h1>
          {notPendingCondition && (
            <MdOutlineClose
              onClick={handleClose}
              size={20}
              className="cursor-pointer"
            />
          )}
        </div>
        {fileList.map((item, _index: number) => (
          <div
            key={_index}
            className="flex items-center justify-between px-4 py-3 gap-2 border-b-[1px] border-grey_1"
          >
            {imgAcceptTypeUpload.includes(item.file.type) ? (
              <Image
                alt="upload-img-icon"
                src={UploadImgIcon}
                width={20}
                height={20}
              />
            ) : (
              <Image
                alt="upload-not-img-icon"
                src={UploadNotImgIcon}
                width={20}
                height={20}
              />
            )}
            <div className="flex-1 truncate text-sm font-medium">
              {item?.file.name}
            </div>
            {item.status === FileUploadStatus.Pending ? (
              <Box sx={{ display: 'flex' }}>
                <CircularProgress size={20} />
              </Box>
            ) : (
              <Image
                alt={
                  item.status === FileUploadStatus.Success
                    ? 'upload-success-icon'
                    : 'upload-error-icon'
                }
                src={
                  item.status === FileUploadStatus.Success
                    ? UploadSuccessIcon
                    : UploadErrorIcon
                }
                width={20}
                height={20}
              />
            )}
          </div>
        ))}
      </div>
    </Snackbar>
  );
};

export default memo(UploadProgress);
